import { Box, CardContent, Divider, Grid, Skeleton } from '@mui/material';

export const SkeletonMenu = () => (
    <Box>
        <CardContent sx={{ p: 2, pb: '16px !important', marginTop: '-15px', ml: '-13px' }}>
            <Grid container>
                <Grid item xs={12} alignItems="center">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Skeleton variant="rounded" width={'70%'} sx={{ my: 2 }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ borderRadius: '8px' }} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                    <Divider />
                </Grid>

                <Grid item xs={12} alignItems="center">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Skeleton variant="rounded" width={'70%'} sx={{ my: 2 }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12} sx={{ mt: 1.3 }}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ borderRadius: '8px' }} />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1.3 }}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ borderRadius: '8px' }} />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1.3 }}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ borderRadius: '8px' }} />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1.3 }}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ borderRadius: '8px' }} />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1.3 }}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ borderRadius: '8px' }} />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1.3 }}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ borderRadius: '8px' }} />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Divider />
                    </Grid>
                </Grid>

                <Grid item xs={12} alignItems="center">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Skeleton variant="rounded" width={'70%'} sx={{ my: 2 }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ mt: 1, borderRadius: '8px' }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ mt: 2 }}>
                    <Divider />
                </Grid>
                <Grid item xs={12} alignItems="center">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Skeleton variant="rounded" width={'70%'} sx={{ my: 2 }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ mt: 1, borderRadius: '8px' }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Skeleton variant="rectangular" height={'40px'} sx={{ mt: 1, borderRadius: '8px' }} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                    <Divider />
                </Grid>
            </Grid>
        </CardContent>
    </Box>
);
